import dynamic from 'next/dynamic';

import { Transformer } from 'src/types/Transformer';
import {
  ButtonSectionProps,
  ButtonTextColorMode,
} from '../../../components/sections/ButtonSection';
import { SectionRenderer } from '../../../types/Section';
import { ButtonSectionContent } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<ButtonSectionProps> = dynamic<ButtonSectionProps>(() =>
  import('../../../components/sections/ButtonSection').then((mod) => mod.ButtonSection),
);

export const transformer: Transformer<ButtonSectionContent, ButtonSectionProps> = ({
  _metadata,
  background_color,
  text_color_mode,
  text,
  href,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  props: {
    customBackgroundColor: background_color,
    textColorMode: text_color_mode as ButtonTextColorMode,
    href,
    children: text,
    trackingTitle: tracking_title,
  },
});
